import React from 'react';
import {
  Avatar,
  Bottom,
  BottomDiv,
  Box,
  ButtonDiv,
  Detail,
  FirstBlock,
  LeftDiv,
  LeftSide,
  Main,
  Profile,
  ResponsiveBottomDiv,
  RightDiv,
  RightSide,
  Square,
  SubBlock,
  Subbox,
  SubDiv,
  Top
} from './styles';

export default function InboxLoading() {
  return (
    <Main>
      <FirstBlock>
        <Avatar>
          <Profile className='loading-animation' />
        </Avatar>
        <RightSide>
          <SubDiv>
            <Top className='loading-animation' />
            <Top className='bottom loading-animation' />
          </SubDiv>
          <Bottom className='loading-animation' />
        </RightSide>
      </FirstBlock>
      <FirstBlock>
        <Avatar>
          <Profile className='loading-animation' />
        </Avatar>
        <RightSide className='right-side'>
          <SubDiv className='right-side'>
            <Top className='loading-animation' />
            <Top className='bottom loading-animation' />
          </SubDiv>
          <ResponsiveBottomDiv className='loading-animation' />
          <LeftSide className='loading-animation' />
        </RightSide>
      </FirstBlock>
      <FirstBlock>
        <Avatar>
          <Profile className='loading-animation' />
        </Avatar>
        <RightSide className='right-side'>
          <Subbox>
            <SubDiv className='right-side third-block'>
              <Top className='loading-animation' />
              <Top className='bottom loading-animation' />
            </SubDiv>
            <SubBlock>
              <Top className='bottomLine loading-animation' />
              <BottomDiv>
                <LeftDiv>
                  <Square className='loading-animation' />
                </LeftDiv>
                <RightDiv>
                  <Detail>
                    <Avatar className='avatar'>
                      <Profile className='avatar loading-animation' />
                    </Avatar>
                    <Top className='right loading-animation' />
                  </Detail>
                  <ButtonDiv>
                    <Bottom className='first loading-animation' />
                    <Bottom className='second loading-animation' />
                  </ButtonDiv>
                </RightDiv>
              </BottomDiv>
            </SubBlock>
          </Subbox>
          <ResponsiveBottomDiv className='loading-animation' />
          <LeftSide className='loading-animation' />
        </RightSide>
      </FirstBlock>
      <FirstBlock className='fourth-block '>
        <Avatar>
          <Profile className='loading-animation' />
        </Avatar>
        <RightSide className='right-side'>
          <SubDiv className='right-side'>
            <Top className='loading-animation' />
            <Top className='bottom loading-animation' />
          </SubDiv>
          <LeftSide className='loading-animation' />
        </RightSide>
      </FirstBlock>
      <FirstBlock className='fifth-block'>
        <Avatar>
          <Profile className='loading-animation' />
        </Avatar>
        <RightSide className='right-side'>
          <SubDiv>
            <Top className='loading-animation' />
            <Box>
              <Top className='top loading-animation' />
              <Top className='top-bottom loading-animation' />
            </Box>
          </SubDiv>
          <LeftSide className='loading-animation' />
        </RightSide>
      </FirstBlock>
    </Main>
  );
}
